import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

// Import all your images
import clinaddis from '../assets/clinaddis.png';
import clinaddis5 from '../assets/clinaddis5.png';
import clinaddis1 from '../assets/clinaddis1.png';
// Import more images from src/images
import image1 from '../images/clinadis1.png';
import image2 from '../images/clinadis2.png';
import image3 from '../images/clinadis3.png';
import image4 from '../images/clinadis4.png';
import image5 from '../images/clinadis5.png';
import image6 from '../images/clinadis6.png';
import image8 from '../images/clinadis8.png';
import image9 from '../images/clinadis9.png';
import image10 from '../images/clinadis10.png';
import image11 from '../images/clinadis11.png';
import image12 from '../images/clinadis12.png';
import image13 from '../images/clinadis13.png';
import image14 from '../images/clinadis14.png';
import image15 from '../images/clinadis15.png';
import image16 from '../images/clinadis16.png';
import image17 from '../images/clinadis17.png';
import image18 from '../images/clinadis18.png';
import image19 from '../images/clinadis19.png';
import image20 from '../images/clinadis20.png';
import image21 from '../images/clinadis21.png';
import image22 from '../images/clinadis22.png';
import image23 from '../images/clinadis23.png';
import image24 from '../images/clinadis24.png';
import image25 from '../images/clinadis25.png';
import image26 from '../images/clinadis26.png';
import image27 from '../images/clinadis27.png';
import image28 from '../images/clinadis28.png';
import image29 from '../images/clinadis29.png';
import image30 from '../images/clinadis30.png';
import image31 from '../images/clinadis31.png';
import image32 from '../images/clinadis32.png';
import image33 from '../images/clinadis33.png';
import image34 from '../images/clinadis34.png';

import './Media.css';

const Media = () => {
  const [activeFilter, setActiveFilter] = useState('all');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  
  // Define categories based on your specification (Art & Medicine Part II merged into Art & Medicine)
  const categories = [
    {
      id: 'storytelling',
      name: 'Storytelling in Medicine',
      date: 'June 21, 2025',
      location: 'Blue Space',
      images: [clinaddis, image1, image2, image3]
    },
    {
      id: 'coffee-medicine',
      name: 'Coffee & Medicine',
      date: 'July 19, 2025',
      location: 'Chaka Coffee',
      images: [image4, image5, image6]
    },
    {
      id: 'art-medicine',
      name: 'Art & Medicine',
      date: 'August 9, 2025',
      location: 'Hilton Hotel & Kikundi Gallery',
      images: [clinaddis1, image8, image9, image10, image26, image27, image28, image29, image30, image31, image32, image33, image34]
    },
    {
      id: 'hands-hearts',
      name: 'Hands & Hearts',
      date: 'September 2, 2025',
      location: 'Cardiac Center',
      images: [clinaddis5, image11, image12, image13, image14, image15]
    },
    {
      id: 'digital-health',
      name: 'Digital Health & AI Learning Sessions',
      date: 'January 26, 2026',
      location: 'Ministry of Health',
      images: [image16, image17, image18, image19, image20, image21, image22, image23, image24, image25]
    }
  ];

  // Generate all media items from categories
  const generateMediaItems = () => {
    let allItems = [];
    let idCounter = 1;
    
    categories.forEach(category => {
      category.images.forEach((image, imageIndex) => {
        // Create two events for Art & Medicine (Part I and Part II)
        let eventDate = category.date;
        let eventDescription = category.description;
        let eventLocation = category.location;
        
        // For Art & Medicine, split into two different events
        if (category.id === 'art-medicine') {
          // First 7 images (index 0-6) are Part I
          if (imageIndex < 7) {
            eventDate = 'August 9, 2025';
          } 
          // Images 7-12 (index 7-12) are Part II
          else {
            eventDate = 'December 27, 2025';
          }
        }
        
        allItems.push({
          id: idCounter++,
          title: `${category.name}${category.id === 'art-medicine' && imageIndex >= 7 ? ' | Part II' : ''}`,
          type: 'gallery',
          program: 'Art & Medicine',
          date: eventDate,
          location: eventLocation,
          category: category.name,
          description: eventDescription,
          image: image,
          slug: `${category.id}-${category.id === 'art-medicine' && imageIndex >= 7 ? 'part2-' : ''}image-${imageIndex + 1}`
        });
      });
    });

    return allItems;
  };

  const allMediaItems = generateMediaItems();
  const ITEMS_PER_PAGE = 6;
  
  // Filter items based on active filter
  const filteredItems = activeFilter === 'all' 
    ? allMediaItems 
    : activeFilter === 'gallery'
    ? allMediaItems
    : allMediaItems.filter(item => item.category === activeFilter);
  
  // Calculate pagination
  useEffect(() => {
    const calculatedTotalPages = Math.ceil(filteredItems.length / ITEMS_PER_PAGE);
    setTotalPages(calculatedTotalPages);
    // Reset to page 1 if current page exceeds total pages after filtering
    if (currentPage > calculatedTotalPages && calculatedTotalPages > 0) {
      setCurrentPage(1);
    }
  }, [filteredItems.length, currentPage]);
  
  // Get current page items
  const getCurrentPageItems = () => {
    const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
    const endIndex = startIndex + ITEMS_PER_PAGE;
    return filteredItems.slice(startIndex, endIndex);
  };
  
  // Generate page numbers for pagination
  const getPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 3;
    
    if (totalPages <= maxVisiblePages + 2) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1);
      
      let start = Math.max(2, currentPage - 1);
      let end = Math.min(totalPages - 1, currentPage + 1);
      
      if (currentPage <= 2) {
        end = 3;
      }
      if (currentPage >= totalPages - 1) {
        start = totalPages - 2;
      }
      
      if (start > 2) {
        pages.push('...');
      }
      
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      
      if (end < totalPages - 1) {
        pages.push('...');
      }
      
      pages.push(totalPages);
    }
    
    return pages;
  };
  
  const handlePageChange = (page) => {
    if (page === '...' || page === currentPage) return;
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  
  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };
  
  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <div className="media-page">
      {/* Hero Section */}
      <section className="section hero-section media-hero">
        <div className="container">
          <h1 className="text-center">Media & Insights</h1>
          <p className="subtitle text-center">
            Explore our gallery and program insights
          </p>
        </div>
      </section>

      {/* Media Gallery Section */}
      <section className="section">
        <div className="container">
          {/* Filters - Updated with categories */}
          <div className="media-filters">
            <div className="filter-container">
              {[
                { id: 'all', label: 'All Media' },
                ...categories.map(category => ({
                  id: category.name,
                  label: category.name
                }))
              ].map(filter => (
                <button
                  key={filter.id}
                  className={`filter-btn ${activeFilter === filter.id ? 'active' : ''}`}
                  onClick={() => {
                    setActiveFilter(filter.id);
                    setCurrentPage(1);
                  }}
                >
                  {filter.label}
                </button>
              ))}
            </div>
          </div>

          {/* Media Grid */}
          <div className="media-grid">
            {getCurrentPageItems().map((item) => (
              <div key={item.id} className="media-card">
                <div className="media-image-container">
                  <img src={item.image} alt={item.title} className="media-image" />
                  <div className="media-type-badge">{item.type}</div>
                </div>
                <div className="media-content">
                  <div className="media-meta">
                    <span className="media-date">{item.date}</span>
                    <span className="media-category">{item.category}</span>
                  </div>
                  <h3 className="media-title">{item.title}</h3>
                  <p className="media-description">{item.description}</p>
                  <div className="media-location">
                    <strong>Location:</strong> {item.location}
                  </div>
                </div>
              </div>
            ))}
          </div>
          
          {/* Pagination */}
          {filteredItems.length > ITEMS_PER_PAGE && (
            <div className="pagination">
              <button 
                className="pagination-btn prev-next"
                onClick={handlePrevPage}
                disabled={currentPage === 1}
              >
                ← Prev
              </button>
              
              {getPageNumbers().map((pageNum, index) => (
                <button
                  key={index}
                  className={`pagination-btn ${pageNum === currentPage ? 'active' : ''} ${pageNum === '...' ? 'ellipsis' : ''}`}
                  onClick={() => handlePageChange(pageNum)}
                  disabled={pageNum === '...'}
                >
                  {pageNum}
                </button>
              ))}
              
              <button 
                className="pagination-btn prev-next"
                onClick={handleNextPage}
                disabled={currentPage === totalPages}
              >
                Next →
              </button>
            </div>
          )}
        </div>
      </section>

      {/* Connect with Programs CTA */}
      <section className="section cta-section">
        <div className="container">
          <div className="text-center">
            <h2>Connect with Our Programs</h2>
            <p className="mb-4">
              Our media showcases the impact of our various programs. Explore how each initiative 
              contributes to healthcare innovation in Ethiopia.
            </p>
            <div className="cta-buttons">
              <Link to="/programs" className="btn btn-primary">View All Programs</Link>
              <Link to="/events" className="btn btn-secondary">See Upcoming Events</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Media;